import React, { useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { MentorListing } from '../../../redux/listing_block/mentor/mentorActions';
import MentorItem from './MentorItem';
import '../Listing.css';

const Mentor = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mentorListing = useSelector((state) => state.MentorListing);
  useEffect(() => {
    if (mentorListing.length === 0) {
      dispatch(MentorListing());
    }
  });

  const handleBack = () => {
    navigate('/listing');
  };
  return (
    <div className="container mt-3">
      <div className="back-header">
        <Button variant="outline-primary backBtn" onClick={handleBack}>Back</Button>
        <h1 className="homepage-heading">Listed Mentors at Business Xchange!</h1>
      </div>
      {mentorListing.length === 0
        ? (
          <h2 className="loading">Loading Listed Mentors...</h2>
        )
        : (
          <ul className="exchange-list-conatiner">
            <div className="card_container">
              {mentorListing.map((mentor) => (
                <MentorItem
                  key={mentor.mobile}
                  mentor={mentor}
                />
              ))}
            </div>
          </ul>
        )}
    </div>
  );
};

export default Mentor;
